import { render, staticRenderFns } from "./new-card.vue?vue&type=template&id=26813d31&scoped=true"
import script from "./new-card.vue?vue&type=script&lang=js"
export * from "./new-card.vue?vue&type=script&lang=js"
import style0 from "./new-card.vue?vue&type=style&index=0&id=26813d31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26813d31",
  null
  
)

export default component.exports